export * from "pleco-default-tone-colors";
export * from "pleco-default-tone-colors/array";
